// extracted by mini-css-extract-plugin
export var dropdown = "_f3-0";
export var imagePlaceholder = "_f3-2";
export var imageWrapper = "_f3-3";
export var productImage = "_f3-1";
export var truncateContainer = "_f3-4";
export var truncateText = "_f3-5";